/**
 * Shared row-action button styles for CMS data tables.
 * Soft tinted chips — keep modules visually aligned.
 */
export const ACTION_BTN_BASE = 'px-3 py-1 rounded text-sm inline-flex items-center space-x-1 transition-colors';

export const actionBtn = {
  view: `text-indigo-600 hover:text-indigo-900 bg-indigo-50 hover:bg-indigo-100 ${ACTION_BTN_BASE}`,
  edit: `text-blue-600 hover:text-blue-900 bg-blue-50 hover:bg-blue-100 ${ACTION_BTN_BASE}`,
  manage: `text-blue-600 hover:text-blue-900 bg-blue-50 hover:bg-blue-100 ${ACTION_BTN_BASE}`,
  duplicate: `text-emerald-600 hover:text-emerald-900 bg-emerald-50 hover:bg-emerald-100 ${ACTION_BTN_BASE}`,
  enroll: `text-emerald-600 hover:text-emerald-900 bg-emerald-50 hover:bg-emerald-100 ${ACTION_BTN_BASE}`,
  approve: `text-green-600 hover:text-green-900 bg-green-50 hover:bg-green-100 ${ACTION_BTN_BASE}`,
  download: `text-blue-600 hover:text-blue-900 bg-blue-50 hover:bg-blue-100 ${ACTION_BTN_BASE}`,
  reject: `text-red-600 hover:text-red-900 bg-red-50 hover:bg-red-100 ${ACTION_BTN_BASE}`,
  delete: `text-red-600 hover:text-red-900 bg-red-50 hover:bg-red-100 ${ACTION_BTN_BASE}`,
  secondary: `text-gray-600 hover:text-gray-900 bg-gray-100 hover:bg-gray-200 ${ACTION_BTN_BASE}`,
};

export default actionBtn;
